import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

import { initTracking } from '../../services/tracking';

const CookieConsent = () => {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    if (typeof window === 'undefined') return;
    const consent = localStorage.getItem('cookie_consent');
    if (consent !== 'accepted') {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    if (typeof window !== 'undefined') {
      try {
        localStorage.setItem('cookie_consent', 'accepted');
      } catch (e) {}
    }
    setVisible(false);
    if (process.env.NODE_ENV === 'production') {
      initTracking();
    }
  };

  const footer = (
    <div className="flex gap-2 justify-content-end">
      <a href="/privacidad" className="p-button p-button-text">Más información</a>
      <Button label="Aceptar" icon="pi pi-check" onClick={handleAccept} />
    </div>
  );

  return (
    <Dialog
      visible={visible}
      onHide={() => setVisible(false)}
      position="bottom"
      dismissableMask={false}
      closeOnEscape={false}
      header="Uso de cookies"
      footer={footer}
      style={{ width: '100%', maxWidth: '640px' }}
    >
      <p className="m-0 text-700 line-height-3">
        Utilizamos cookies y tecnologías similares para mejorar tu experiencia,
        medir el tráfico y personalizar contenidos. Al hacer clic en "Aceptar",
        autorizas el uso de cookies conforme a nuestra <a href="/privacidad" className="text-primary">Política de Privacidad</a>.
      </p>
    </Dialog>
  );
};

export default CookieConsent;